import request from 'utils/request'

// 获取列表数据
export const getTableData = data =>
  request().post('oneselfExamine/page', data)

// 添加条件
export const add = data => request().post('oneselfExamine/add', data)

// 编辑
export const update = data =>
  request().post('oneselfExamineCondition/update', data)

// 删除
export const remove = id =>
  request().get(`oneselfExamineCondition/delete/${id}`)

// 获取自定义评分卡列表
export const getCardList = () =>
  request().post('oneselfExamine/ratingCard/list')

// 获取等级下拉选列表
export const getCustomGrading = () =>
  request().post('oneselfExamine/customGrading/list')

//获取条件中已设置的业务类型
export const getBusiness = () => request().get('oneselfExamine/business')

// 获取业务类型select数据
export const getBusinessTypeList = () => request().get('business/list')

// 获取大区select数据
export const getRegionOptionList = pid =>
  request().get(`business/region/${pid}`)

// 获取业务模式select数据
export const getModelOptionList = pid => request().get(`business/model/${pid}`)

//获取Segmentselect数据
export const getSegmentOptionList = pid =>
  request().get(`sysSegment/list/${pid}`)

//获取法人主体select数据
// export const getLegalOptionList = () => request().get('/legal/list')
